import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { scrollToId } from "./Navbar";

const STEPS = [
  {
    n: "01",
    title: "We paint",
    body: "Tell us about the sale. We quote free, then transform the home inside or out — fast, particular, market-ready.",
    testid: "step-paint",
  },
  {
    n: "02",
    title: "Your home sells for more",
    body: "First impressions set the price. A fresh finish lifts the photos, the inspections and the offers.",
    testid: "step-sells",
  },
  {
    n: "03",
    title: "You pay at settlement",
    body: "Nothing upfront. The invoice is settled from the sale itself — simple, signed, sorted.",
    testid: "step-settlement",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-20">
        <div>
          <Reveal>
            <SectionLabel>How It Works</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-8">
              Paint now.{" "}
              <span className="italic text-ember">Pay at settlement.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <button
            data-testid="how-it-works-quote-cta"
            onClick={() => scrollToId("#quote")}
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-ember hover:gap-4 transition-[gap] duration-300"
          >
            Start with a free quote
            <ArrowUpRight size={14} strokeWidth={1.5} />
          </button>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-px bg-line border border-line">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12} y={40} className="bg-coal">
            <div
              data-testid={s.testid}
              className="group bg-coal hover:bg-ash/60 transition-colors duration-500 p-10 md:p-12 h-full"
            >
              <span className="font-serif font-light text-6xl md:text-7xl text-outline-ember leading-none select-none transition-all duration-500 group-hover:[-webkit-text-stroke-color:rgba(252,153,7,1)]">
                {s.n}
              </span>
              <h3 className="font-serif text-2xl md:text-3xl font-normal tracking-tight mt-10">
                {s.title}
              </h3>
              <p className="text-smoke font-light leading-relaxed mt-4 text-base">
                {s.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
